import { render, staticRenderFns } from "./bindService.vue?vue&type=template&id=545b8fc3&scoped=true&"
import script from "./bindService.vue?vue&type=script&lang=js&"
export * from "./bindService.vue?vue&type=script&lang=js&"
import style0 from "./bindService.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./bindService.vue?vue&type=style&index=1&id=545b8fc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b8fc3",
  null
  
)

export default component.exports